<template>
  <div>
    <div class="mg-y-10 tx-18" style="color: #21242e">{{title}}</div>
    <div v-if="list.length == 0" >
      <div class="bg-white rounded-20 mg-t-50 text-center pd-10">
        <div class="" style="margin-top: -50px">
          <img :src="`${myResBaseUrl}v4-assets/img2.png`" />
        </div>
        <div class="mg-t-10 text-muted">Сайн байна уу</div>
        <h6 v-if="hasPermission(['stf_ubeg'])">
          Танд албан бичиг хүргүүлэх төслийн мэдээлэл байхгүй байна
        </h6>
        <h6 v-else>
          Танд танилцах төслийн мэдээлэл байхгүй байна
        </h6>
        <button
          type="button"
          class="btn btn-primary btn-icon mg-t-10 rounded-20"
          style="margin-bottom: -25px"
        >
          <feather type="arrow-up" :width="32" :height="32"></feather>
        </button>
      </div>
    </div>

    <div v-else class="wd-100p">
      <div class="d-flex">
        <div class="mg-l-auto wd-300">
          <input class="form-control mg-b-10" type="text" v-model="regno" placeHolder="Регистерийн дугаараар хайх" />
        </div>
      </div>
      <table class="table table-bordered table-striped">
        <thead class="thead-primary">
          <tr>
            <th>Д/д</th>
            <th>Хуулийн этгээдийн нэр</th>
            <th>Регистрийн дугаар</th>
            <th v-if="hasPermission(['stf_ubeg'])">Инновацийн төслийн нэр</th>
            <th v-else>Бүтээгдэхүүн, ажил, үйлчилгээний нэр</th>
            <th>Төсөл хэрэгжүүлэх хугацаа</th>
            <th>Гарааны компани / Програм хангамжийн компани</th>
          </tr>
        </thead>
        <tbody>
          <tr @click="setMark(l.projectTask.id)" role="button" v-for="(l, i) in getItems" :key="i">
            <td>{{ i+1 }}</td>
            <td>{{ l.companyTask.name }}</td>
            <td>{{ l.companyTask.regNo }}</td>
            <td v-if="hasPermission(['stf_ubeg'])">{{ l.projectTask.task }}</td>
            <td v-else>{{ l.projectTask.s16 }}</td>
            <!-- <td>{{ l.zarTask.task }} ({{ l.zarTask.type.name }})</td> -->
            <td>
              <span class="d-block text-muted text-right"
                >{{ l.zarTask.d3 | moment("YYYY.MM.DD") }} -
                {{ l.zarTask.d4 | moment("YYYY.MM.DD") }}</span>
            </td>
            <td>{{ l.projectTask.locType7Name }}</td>
          </tr>
        </tbody>
      </table>
      <!-- <div class="card-header">{{ l.zarTask.type.name }}</div>
      <div class="card-body pd-0-f">
        <ul class="mg-b-0">
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Төслийн нэр</h6>
              <span class="d-block tx-11 text-muted">{{ l.projectTask.task }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Төслийн зар</h6>
              <span class="d-block tx-11 text-muted">{{ l.zarTask.task }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Хэрэгжих хугацаа хугацаа</h6>
              <span class="d-block tx-11 text-muted"
                >{{ l.zarTask.d3 | moment("YYYY.MM.DD") }} -
                {{ l.zarTask.d4 | moment("YYYY.MM.DD") }}</span
              >
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Компанийн нэр</h6>
              <span class="d-block tx-11 text-muted">{{ l.companyTask.name }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Компанийн регистр</h6>
              <span class="d-block tx-11 text-muted">{{ l.companyTask.regno }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-footer">
        <button @click="setMark(l.projectTask.id)" class="mg-l-auto btn btn-info btn-xs">
          Дэлгэрэнгүй
        </button>
      </div>
    </div> -->
</div>
    <b-modal
      v-model="markObj.modal"
      body-class="test-modal-body bg-light ht-100v"
      dialog-class="test-modal-dialog"
      centered
      scrollable
      title="Төслийн дэлгэрэнгүй"
    >
      <div class="ht-100v">
        <div class="d-flex">
          <!-- <div class="wd-50p pd-20">
            <task-info
              class="wd-100p bg-white rounded-20 bd pd-20"
              :fields="markObj.fields"
              :obj="{ data: { task: markObj.task } }"
              :loaded="markObj.fetched"
              :boxId="0"
              :parentTask="null"
              @on-attach="showFile"
            />
          </div> -->
          <div class="wd-100p pd-20" v-if="markObj.fetched">
            <div v-if="hasPermission(['stf_ubeg'])" class="wd-100p bg-white rounded-20 bd pd-20">
              <Form label-position="top" label-width="100%">
                <FormItem label="Албан бичиг">
                  <simple-uploader
                    :propObjectId="6"
                    :propObjectTypeId="6"
                    @on-success="fileUploadedSetting"
                    class="wd-100p"
                  >
                    <div slot="trigger" class="wd-100p">
                      <a v-if="postObj.defaultAttachmentId == 0 || postObj.defaultAttachmentId == null"
                        class="dropdown-item" >Компьютероос хуулах
                      </a>
                      <div v-else class="btn-group wd-100p">
                        <div class="btn btn-outline-success" @click.stop="markObj.modal = false; $emit('on-attach', postObj.defaultAttachmentId)">
                          <feather type="eye"></feather>Файл харах
                        </div>
                        <div class="btn btn-danger" @click.prevent.stop="postObj.defaultAttachmentId = null">
                          <feather type="x"></feather>Салгах
                        </div>
                      </div>
                    </div>
                  </simple-uploader>
                </FormItem>
                <FormItem>
                  <a @click="saveFilePre()" class="btn btn-success" role="button">Файл хадгалах</a>
                </FormItem>
              </Form>
            </div>
            
                    <!-- <div v-for="(b, i) in markObj.task.b" :key="i">{{ b.nm }}
                      
                    </div> -->
            <!-- <h1>энд box зурах гээд bug тай үлдээсэн :D</h1> -->

            <div v-for="(b, i) in markObj.task.b" :key="i" class="mg-b-20">
              <h6 class="tx-uppercase tx-semibold mg-b-0">
                  {{ i + 1 }}. {{ b.nm }}
                </h6>
              <loader
                :ref="`ldr_box_${b.id}`"
                :box="b"
                :prms="{ boxChooser: false }"
                :detailSettingProp="{
                  boxSetting: {
                    listSetting: { height: 0 },
                    hideToolbar: true,
                    hideEmptyTemplate: true,
                    autoHeight: true,
                    hideFooter: true,
                  },
                }"
                @on-attach="showFile($event)"
                @on-detail="showDetail"
                @load-box="loadBoxData"
              />
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <!-- <p class="float-left">энд тайлбар бичнэ</p> -->
          <b-button v-if="hasPermission(['stf_ubeg'])" variant="primary" size="sm" class="float-right" @click="postPoints()">
            Илгээх
          </b-button>
        </div>
      </template>
    </b-modal>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getDetailFields } from "@/api/taskCore";

import loader from "@/components/box/loader/loader.vue";

import "element-ui/lib/theme-chalk/index.css";
import { Message, InputNumber, MessageBox, Form, FormItem } from "element-ui";

import { hasOneOf } from "@/libs/tools";

export default {
  components: {
    loader,
    Form, FormItem,
    InputNumber,
    MessageBox, Message,
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      regno: "",
      postObj:{
        defaultAttachmentId: null,
      },
      fileDialog: {
        id: null,
        show: false,
      },
      markObj: {
        fields: [],
        task: {
          b: [],
        },
        id: null,
        modal: false,
        fetched: false,
      },
      pointsDta: {
        points: [],
        projectTaskId: null,
      },
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
  },
  computed: {
    getItems() {
      return this.list.filter((item) => item.companyTask.regNo.toLowerCase().includes(this.regno.toLowerCase()));
    },
  },
  methods: {
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    },
    saveFilePre(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "ProjectEdu/SendAlbanBichig" },
        data: { id: this.markObj.id, attachmentId: this.postObj.defaultAttachmentId },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          Message({
            type: 'info',
            message: `файлыг илгээлээ`
          });
          //console.log('res', res);
        }
      });
    },
    fileUploadedSetting(e) {
      this.postObj.defaultAttachmentId = e.uploadedAttachmentId;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    setMark(id) {
      // console.log('setMark');
      if(this.hasPermission(['stf_gaali'])){
        this.toggleBodyClass("addClass", "dynamic-locker");
        getDetailFields({ params: { objectTypeId: 561 } }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.markObj.fields = res.data.fields;
            this.markObj.fetched = true;
            this.toggleBodyClass("addClass", "dynamic-locker");
            request({
              api: { method: "GET", url: "task/TaskInheritedDetail" },
              params: { id: id },
              store: this.$store,
            }).then((rest) => {
              this.toggleBodyClass("removeClass", "dynamic-locker");
              if (rest != false) {
                this.markObj.task = rest.data.task;
                if(this.hasPermission(['stf_tax', 'stf_gaali'])){
                  this.markObj.task.b=this.markObj.task.b.filter(x=>x.ot==586 || x.ot==587);
                }
                //this.markObj.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});


                this.markObj.id = id;
                this.markObj.modal = true;

                //this.getMyPoints(id);
              }
            });
          }
        });
      }
    },
    getMyPoints(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ProjectEdu/GetMyPointsByProjectTaskId" },
        params: { projectTaskId: id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.pointsDta = res.data;
          //console.log('res', res);
        }
      });
    },
    showFile(e) {
      // console.log('e', e);
      this.markObj.modal= false;
      this.fileDialog.id = e;
      this.fileDialog.show = true;
    },
    showDetail() {},
    loadBoxData() {},
    postPoints() {
      MessageBox.confirm("Та итгэлтэй байна уу ?", "Санам", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        type: "warning",
      })
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "ProjectEdu/SendFromUbegToYam" },
            data: {
              id: this.markObj.id
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (res != false) {
              //console.log("res", res);
              this.markObj.modal = false;
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
.test-modal-body {
  /* width: calc(100% - 2rem);
    min-height: 100%;
    height: auto;
    margin: 1rem; */
  margin: 0;
  padding: 0;
}

.test-modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
